export default "__VITE_ASSET__049ffd14__"